import React from 'react';
import '../CSS/Footer.css'; // フッター用のCSSを適用

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2025 株式会社　妙香. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
